import { type IngestionRuleRecord } from "./IngestionRuleRecord";

/**
 * What ingests a rule's files: its action (`on`), nobody while its saved action
 * is switched off (`paused`), or something outside the rule because it has no
 * action (`no-action`). Sessions wait for the files in every state.
 */
export type AutoIngestState = "on" | "paused" | "no-action";

export function autoIngestStateOf(
  rule: Pick<IngestionRuleRecord, "auto_ingest" | "invocation">,
): AutoIngestState {
  if (rule.invocation === null) {
    return "no-action";
  }
  return rule.auto_ingest ? "on" : "paused";
}
